// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"53221532","825":"b9d46dc3"}[chunkId] + ".chunk.js";
};